module.exports = __webpack_public_path__ + "static/media/singletrail.aa98432f.png";